import { z } from 'zod';

export const reviewedCountSchema = z.object({
  collectionId: z.number(),
  reviewedCount: z.number(),
});

export type IReviewedCount = z.infer<typeof reviewedCountSchema>;
